export const AB_TESTS_NAMES = {
    LANDING_PAGE: 'landing_page',
    MOBILE_DEPOSIT_BONUS_PRIMARY_BUTTON: 'mobile_deposit_bonus_primary_button',
    REGISTER_FIELD_PHONE: 'register_field_phone',
}

export const AB_TESTS_LANDING_PAGE_OPTIONS = {
    INITIAL: 0,
    REDESIGN: 1,
}

export const AB_TEST_MOBILE_DEPOSIT_BONUS_PRIMARY_BUTTON_OPTIONS = {
    GET_APP: 0,
    CASHIER: 1,
}

export const AB_TEST_REGISTER_FIELD_PHONE_OPTIONS = {
    SHOW: 0,
    HIDE: 1,
}
